import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../theme';
import {isWeb} from '../../../constants';

export default StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'stretch',
  },
  obstacleView: {
    width : '100%' , 
    height : '100%' , 
    position : 'absolute' , 
    top : 0 , 
    zIndex: 100,
  },
  input: {
    flex: isWeb ? 1 : undefined,
    alignSelf: 'stretch',
    fontFamily: textStyles.regular,
    fontSize: 16,
    color: colorPalette.grey8_5,
    margin: 0,
    paddingVertical: 0,
    textAlign: 'right',
    paddingHorizontal: 16,
    backgroundColor: colorPalette.whiteGrey0,
  },
  label: {
    fontFamily: textStyles.regular,
    fontSize: 16,
    color: colorPalette.grey5,
  },
  underline: {
    width: 0,
    height: 0,
  },
});
